const searchConstants = {
  SEARCH: "SEARCH",
  CLEAR_SEARCH_RESULTS: "CLEAR_SEARCH_RESULTS",
  CHANGE_HAS_MORE_RESULTS_FLAG: "CHANGE_HAS_MORE_RESULTS_FLAG",
  CHANGE_FILTER: "CHANGE_FILTER",
  CHANGE_LAST_RESULT: "CHANGE_LAST_RESULT",
  LOAD_MORE_SEARCH_RESULTS: "LOAD_MORE_SEARCH_RESULTS"
};
export default searchConstants;



// WEBPACK FOOTER //
// ./src/_constants/searchConstants.js